// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"419":"3f3fd61c","690":"07e12b22"}[chunkId] + ".chunk.css";
};